import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import ForcedMessage from 'widgets/forced-notifications/partials/ForcedMessage'
import ForcedChecklists from 'widgets/forced-notifications/partials/ForcedChecklists'
import ForcedContracts from 'widgets/forced-notifications/partials/ForcedContracts'

export default function DisplayForcedNotifications () {
  const [forcedNotifications] = useEnvValue('forced_notifications', {})

  const messages = forcedNotifications.messages || []
  if (messages.length > 0) {
    return <ForcedMessage message={messages[0]} />
  }

  const checklists = forcedNotifications.checklists || []
  if (checklists.length > 0) {
    return <ForcedChecklists checklists={checklists} />
  }

  const contracts = forcedNotifications.contracts || []
  if (contracts.length > 0) {
    return <ForcedContracts contracts={contracts} />
  }

  return null
}
